import { MessageTemplateCreateMethodTypes } from "@enums/message-template-create-method-types";
import { SelectOption } from "@idw-types/common";

export const MESSAGE_TEMPLATE_CREATE_METHOD_OPTIONS: Array<SelectOption<MessageTemplateCreateMethodTypes>> = [
    {
        label: "Create a verification link template from scratch",
        value: MessageTemplateCreateMethodTypes.CREATE_FROM_SCRATCH
    },
    {
        label: "Create a new verification link template using an existing template as the starting point",
        value: MessageTemplateCreateMethodTypes.USE_TEMPLATE
    }
];